import Accordion from 'accordion-js';
import 'accordion-js/dist/accordion.min.css';

function initAccordions() {
  const accordLists = document.querySelectorAll('.accord');

  accordLists.forEach(list => {
    // Якщо вже було ініціалізовано — очищаємо DOM методом "клонування"
    if (list.dataset.accordionInit === 'true') {
      const cleanList = list.cloneNode(true);
      list.replaceWith(cleanList);
      list = cleanList;
    }

    // Позначаємо як ініціалізований
    list.dataset.accordionInit = 'true';

    // Ініціалізуємо Accordion.js
    new Accordion(list, {
      duration: 400,
      showMultiple: false,
    });

    // Відключаємо закриття при кліку на контент
    list.querySelectorAll('.ac-panel').forEach(panel => {
      panel.addEventListener('click', e => e.stopPropagation());
    });
  });
}

// --- 1) Початкове завантаження
document.addEventListener('DOMContentLoaded', () => {
  initAccordions();
});

// --- 2) FacetWP перерендерив контент
document.addEventListener('facetwp-loaded', () => {
  initAccordions();
});
